import { useRecoilValue } from 'recoil';
import OnCall from './components/OnCall';
import UserData from './components/UserData';
import NavigationList from './components/NavigationList';
import { SidebarContainer } from './styles';
import sidebarState from '../../stores/atoms/sidebarAtom';
import { Snackbar } from '@mui/material';
import { snackbarMessageState, snackbarStatus } from '../../stores/selectors/snackbarSelector';
import { SidebarControl } from './components/SidebarControl';
import LogoButton from '../../components/LogoButton';
import { ScrollArea } from '../../lib/scroll-area';

const Sidebar = () => {
    const sidebarOpen = useRecoilValue(sidebarState);
    const msgSnackbar = useRecoilValue(snackbarMessageState);
    const statusSnackbar = useRecoilValue(snackbarStatus);
    const packageJson = require('../../../package.json');

    return (
        <SidebarContainer open={sidebarOpen}>
            <div className={`h-page ${sidebarOpen ? 'w-[240px]' : 'w-[68px]'}`}>
                <ScrollArea className="h-full" type="auto">
                    <div className={`relative flex flex-col gap-10 py-4 ${sidebarOpen ? 'px-6' : 'px-2'}`}>
                        <div className="flex justify-between items-center">
                            {sidebarOpen && <LogoButton />}
                            <SidebarControl />
                        </div>
                        <div className="flex flex-col gap-4">
                            <UserData />
                            <OnCall />
                        </div>
                        <NavigationList />
                        {sidebarOpen && (
                            <div className="border text-xs color-grey-800 p-2 rounded-lg w-fit ml-4">
                                {packageJson.version} version
                            </div>
                        )}
                        <Snackbar open={statusSnackbar} message={msgSnackbar} />
                    </div>
                </ScrollArea>
            </div>
        </SidebarContainer>
    );
};

export default Sidebar;
